webpackJsonp([2],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_libs_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_topbar_menu__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_utils__ = __webpack_require__(2);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */






function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["g" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_3_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.banner-apply-btn').click(function () {
    var $this = $(this);
    var href = Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["a" /* addCurrentPageParams */])($this.data('href'));
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["g" /* toUrl */])(href, '_blank');
  });
}

function init() {
  Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
  bindEvent();
}
init();

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exLists; });
var exLists = {
  novel: {
    putonghua: [{
      name: '水哥',
      enName: 'x_xiaoxi',
      type: '普通话',
      photo: 'hongshu.png',
      language: 'intp65',
      tag: '推荐',
      desc: '稳重磁性',
      text: '可遇不可求的事，后海有树的院子，夏代有工的玉，此时此刻的云，二十来岁的你。'
    }, {
      name: '万叔',
      enName: 'x_wanshu',
      type: '普通话',
      photo: 'hongshu.png',
      language: 'intp65',
      tag: '推荐',
      desc: '浑厚磁性',
      text: '草在结它的种子，风在摇它的叶子，我们站着，不说话，就十分美好。'
    }, {
      name: '逍遥子',
      enName: 'x_xiaohou',
      type: '普通话',
      photo: 'hongshu.png',
      language: 'intp65',
      tag: '推荐',
      desc: '亲和时尚',
      text: '黑夜给了我黑色的眼睛，我却用它寻找光明。'
    }, {
      name: '宁宁',
      enName: 'x_ningning',
      type: '普通话',
      photo: 'xiaoyu.png',
      photoType: 'type2',
      language: 'intp65',
      tag: '推荐',
      desc: '甜美可爱',
      text: '床前明月光，疑是地上霜。举头望明月，低头思故乡。'
    }, {
      name: '小雪',
      enName: 'x_xiaoxue',
      type: '普通话',
      photo: 'dengziqi.png',
      language: 'intp65',
      tag: '推荐',
      desc: '成熟知性',
      text: '你站在桥上看风景，看风景的人在楼上看你。明月装饰了你的窗，你装饰了别人的梦。'
    }, {
      name: '一萍',
      enName: 'x_yiping',
      type: '普通话',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '温柔知性',
      text: '公元前我们还太小，公元后我们又太老，没有谁见过，那一次真正美丽的微笑。'
    }, {
      name: '小媛',
      enName: 'x_xiaoyuan',
      type: '普通话',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '亲和自然',
      text: '这本书的作者是来自于Harvard University的 Stephen curry，Stephen curry在他的书中提出了一种LSTM模型，这个LSTM模型很好的解释了wave-particle duality 现象。'
    }, {
      name: '刚哥',
      enName: 'x_xiaozhang',
      type: '普通话',
      photo: 'hongshu.png',
      language: 'intp65',
      desc: '成熟亲和',
      text: '从前的日色变得慢，车，马，邮件都慢，一生只够爱一个人。'
    }, {
      name: '小魏',
      enName: 'x_xiaowei',
      type: '普通话',
      photo: 'hongshu.png',
      language: 'intp65',
      desc: '成熟亲和',
      text: '你从远方来，我到远方去，遥远的路程经过这里。天空一无所有，为何给我安慰。'
    }, {
      name: '晓婧',
      enName: 'x_jinger',
      type: '普通话',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '亲切自然',
      text: '我的志愿是做一个校长，每天收集了学生的学费之后就去吃火锅。今天吃麻辣火锅，明天吃酸菜鱼火锅，后天吃猪骨头火锅。'
    }, {
      name: '小萍',
      enName: 'aisxping',
      type: '普通话',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '温柔知性',
      text: '我们都是好朋友吧，所以你的东西就是我的东西，我的东西还是我的东西。'
    }, {
      name: '许小宝',
      enName: 'aisbabyxu',
      photo: 'xiaoyu.png',
      photoType: 'type2',
      language: 'intp65',
      desc: '童真可爱',
      text: '如果没有任意门、没有时光机、没有竹蜻蜓、没有记忆面包，如果只是一只简单的讲义气的机器猫。'
    }],
    other: [{
      name: '小梅',
      enName: 'x_xiaomei',
      photo: 'dengziqi.png',
      language: 'intp65',
      tag: '广东话',
      desc: '亲和自然',
      text: '每个人嘅一生中总回将自己的秘密封锁喺心入面，倘若有一个人，手握住一把钥匙，去开启你嘅心锁，咁佢就应该系你嘅真命天子。'
    }, {
      name: 'Catherine',
      enName: 'x_catherine',
      photo: 'twpt.png',
      photoType: 'type2',
      language: 'intp65',
      tag: '英文',
      desc: '成熟亲和',
      text: 'If I can see you after a long year, how can I greet?'
    }, {
      name: 'john',
      enName: 'x_john',
      photo: 'lizhengchun.png',
      language: 'intp65',
      tag: '英文',
      desc: '亲和磁性',
      text: 'If you reveal your secrets to the wind you should not blame.'
    }]
  },
  news: [{
    name: '一萍',
    enName: 'x_yiping',
    type: '普通话',
    photo: 'dengziqi.png',
    language: 'intp65',
    tag: '推荐',
    desc: '温柔知性',
    text: '大湖之北，绝艳江城，楚文化独领风骚数百年。我们相信，先祖祝融最终浴火而生，化为神鸟凤凰，飞登九天。奔流不息的时间长河，终将这一刹那，冲刷成永恒，铭刻在这里。'
  }, {
    name: '小魏',
    enName: 'x_xiaowei',
    type: '普通话',
    photo: 'hongshu.png',
    language: 'intp65',
    tag: '推荐',
    desc: '成熟亲和',
    text: '我们探索着勾践剑无与伦比的浩瀚风景，也探索着先人无与伦比的智慧，这是时代进步，科技进步赋予我们的机遇，让我们能从另一个维度解读国宝，窥见历史。'
  }, {
    name: '小媛',
    enName: 'x_xiaoyuan',
    photo: 'dengziqi.png',
    language: 'intp65',
    tag: '推荐',
    desc: '亲和自然',
    text: '当一个伟大的时代来临的时候，其实有很多的小人物，都在兢兢业业地做好着自己应该做的事情，当我们每一个人都能把自己所承载的工作做到位的时候，这个时代，一定是一个伟大的时代。'
  }, {
    name: '马叔',
    enName: 'x_laoma',
    photo: 'lnns.png',
    photoType: 'type2',
    language: 'intp65',
    tag: '推荐',
    desc: '和蔼亲和',
    text: '每一座博物馆都是民族文化基因的宝库，每一件文物的生命轨迹都让人为之叹服。'
  }, {
    name: '小薛',
    enName: 'x_xiaoxue_daqi',
    photo: 'dengziqi.png',
    language: 'intp65',
    desc: '甜美自然',
    text: '广厦千间，夜眠仅需六尺；家财万贯，日食不过三餐！这是巨变的中国，人和食物，比任何时候走的更快。'
  }, {
    name: '虫虫',
    enName: 'x_chongchong',
    photo: 'dengziqi.png',
    language: 'intp65',
    desc: '温柔甜美',
    text: '不管是否情愿，生活总在催促我们迈步向前，人们整装，启程，跋涉，落脚，停在哪里，哪里就会燃起灶火。从个体生命的迁徙，到食材的交流运输，从烹调方法的改变，到人生命运的流转，人和食物的匆匆脚步，从来不曾停歇。'
  }, {
    name: '许久',
    enName: 'aisjiuxu',
    photo: 'hongshu.png',
    language: 'intp65',
    desc: '亲切自然',
    text: '在中国大陆和宝岛台湾之间，一片浩浩淼淼的水域，如繁星般洒落着千礁百岛，海阔潮涌，天风吹梦。这就是福建平潭。'
  }, {
    name: '水哥',
    enName: 'x_xiaoxi',
    photo: 'hongshu.png',
    language: 'intp65',
    desc: '稳重磁性',
    text: '小麦，曾经改变人类文明进程的作物，拥有世界上广泛的种植面积，从最日常的馒头、面条、锅盔，到肉夹馍、羊肉泡，再到花样百出的各色小吃，共同奠定了陕西这个面食王国难以撼动的基石。'
  }],
  humancomputer: [{
    name: 'Catherine',
    enName: 'x_catherine',
    photo: 'twpt.png',
    photoType: 'type2',
    language: 'intp65',
    tag: '英文',
    desc: '成熟亲和',
    text: 'If I can see you after a long year, how can I greet?'
  }, {
    name: '小师',
    enName: 'x_xiaoshi_cts',
    photo: 'dengziqi.png',
    language: 'intp65',
    tag: '推荐',
    desc: '甜美亲和',
    text: '仰望星空，地球是宇宙给人类的礼物；低头凝望，一花一叶，是大自然给世界的礼物。'
  }, {
    name: '小丸子',
    enName: 'x_xiaowanzi',
    photo: 'nannan.png',
    language: 'intp65',
    tag: '推荐',
    desc: '活泼可爱',
    text: '兰州人都说，自己的早晨是从一碗牛肉拉面开始的，这个有着一千多家拉面馆的城市，每天要消耗一百万碗拉面。'
  }, {
    name: '小光',
    enName: 'x_xiaoguan',
    photo: 'hongshu.png',
    language: 'intp65',
    tag: '推荐',
    desc: '饱满活泼',
    text: '你一会看我，一会看云，你看我时很远，你看云时很近。'
  }, {
    name: '小媛',
    enName: 'x_xiaoyuan',
    photo: 'dengziqi.png',
    language: 'intp65',
    tag: '推荐',
    desc: '亲和自然',
    text: '你来人间一趟，你要看看太阳，和你的心上人，一起走在大街上。'
  }, {
    name: '楠楠',
    enName: 'x_nannan',
    photo: 'nannan.png',
    language: 'intp65',
    desc: '活泼可爱',
    text: '我希望童年快乐，找到亲爱的小伙伴，和她在泥坑里跳来跳去。'
  }, {
    name: '许小宝',
    enName: 'aisbabyxu',
    photo: 'xiaoyu.png',
    photoType: 'type2',
    language: 'intp65',
    desc: '童真可爱',
    text: '幸福是什么，幸福就是猫爱吃鱼，狗爱吃肉，奥特曼爱打小怪兽。'
  }, {
    name: '水哥',
    enName: 'x_xiaoxi',
    photo: 'hongshu.png',
    language: 'intp65',
    desc: '稳重磁性',
    text: '可遇不可求的事，后海有树的院子，夏代有工的玉，此时此刻的云，二十来岁的你。'
  }, {
    name: '春春',
    enName: 'x_chunchun',
    photo: 'dengziqi.png',
    language: 'intp65',
    desc: '温柔甜美',
    text: '原来有些东西，没有就是没有，不行就是不行，我却还以为世间的一切，都该有商量的余地。'
  }, {
    name: '晓婧',
    enName: 'x_jinger',
    photo: 'dengziqi.png',
    language: 'intp65',
    desc: '亲切自然',
    text: '我的志愿是做一个校长，每天收集了学生的学费之后就去吃火锅。今天吃麻辣火锅，明天吃酸菜鱼火锅，后天吃猪骨头火锅。'
  }]
};



/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getServiceOpenApps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMobileappSdkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return openService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return openOcrService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return openNewFrameService; });
/* unused harmony export webTTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mtranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return lexicalAnalysist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOtsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getItsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return productKesa; });
/* unused harmony export getOnlineAudioSrc */
/* unused harmony export getVoiceAudioSrc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIatSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIatLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTtsSpeakList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTtsSign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__ = __webpack_require__(6);
/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */




/**
 * 获取用户app
 * @param servicesId
 * @returns {Promise}
 */
function getServiceOpenApps(servicesId, getAppUrl) {
  return new Promise(function (resolve, reject) {
    var url = '/herapi/user/get_app_list_by_service?service_id=' + btoa(servicesId);
    jQuery.ajax({
      url: getAppUrl || url,
      type: 'get',
      dataType: 'json',
      success: function success(data) {
        resolve({
          code: 0,
          data: data
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取用户app
 * 代替getServiceOpenApps
 */
function getApps() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getAppList',
      type: 'get',
      dataType: 'json',
      cache: false,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {
        resolve({});
      }
    });
  });
}

/**
 * 开通服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'mycloud/app/accessService',
      dataType: 'json',
      data: {
        'app_id': appId,
        'service': servicesId
      },
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 开通ocr服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openOcrService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/app/jsonp/service/add',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 开通新框架服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openNewFrameService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/webapi/jsonp/addService/v1',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 语音合成的接口
 * @param params：
 * {
 *   vcn: aisxping,
 *   vol: 7,
 *   spd: medium,
 *   textPut: '', // 输入的文本
 * }
 * @returns {Promise}
 */
function webTTS(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'post',
      url: '/herapi/solution/synthesis',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function mtranslate(params) {
  // {
  //   fromLang: trans.data.source,
  //     toLang: trans.data.dist,
  //   originText: text
  // }
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/translate',
      type: 'post',
      data: params,
      success: function success(result) {
        // result.code = result.flag ? 0 : -1
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取开放统计的sdkList
 * @returns {Promise}
 */
function getMobileappSdkList() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/getSdkList',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 词法分析接口
 * @returns {Promise}
 */
function lexicalAnalysist(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/index/webltp',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译niutrans体验接口
 * @returns {Promise}
 */
function getOtsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/ots',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译体验接口
 * @returns {Promise}
 */
function getItsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/its',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 关键词提取type传：ke
 * 如果是调用情感分析type传：sa
 * 关键词 && 情感分析接口
 * @returns {Promise}
 */
function productKesa(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/kesa',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取在线语音合成的音频src
 * @returns {Promise}
 */
function getOnlineAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/synthesis/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getVoiceAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/dictation/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取极验数据进行初始化
 * @returns {Promise}
 */
function getValidate() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/plug/validate',
      type: 'get',
      cache: false,
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}
/**
 * 获取听写websocket链接
 * @returns {Promise}
 */
function getIatSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getIatLanguage() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_language_list',
      type: 'post',
      dataType: 'json',
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取合成websocket链接
 * @returns {Promise}
 */
function getTtsSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 合成体验发音人参数列表获取接口
 * @param grade 发音人等级（默认是0，0特色发音人，1精品发音人）
 * @returns {Promise}
 */
function getTtsSpeakList(_ref) {
  var _ref$grade = _ref.grade,
      grade = _ref$grade === undefined ? 0 : _ref$grade;

  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_language_list',
      type: 'post',
      dataType: 'json',
      data: {
        grade: grade
      },
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}



/***/ }),

/***/ 175:
/***/ (function(module, exports) {

(function ($) {
  $.extend($.fn, {
    /* 实现一个jquery滑动条插件 类似于： hmtl5 的input type=number */
    jSlider: function jSlider(setting) {
      var ps = $.extend({
        renderTo: $(document.body),
        enable: true,
        initPosition: 0,
        size: { barWidth: 200, sliderWidth: 5 },
        barCssName: 'defaultbar',
        completedCssName: 'jquery-completed',
        sliderCssName: 'jquery-jslider',
        sliderHover: 'jquery-jslider-hover',
        onChanging: function onChanging() {},
        onChanged: function onChanged() {}
      }, setting);

      // 强制将renderTo强制转换成jQuery对象
      ps.renderTo = typeof ps.renderTo === 'string' ? $(ps.renderTo) : ps.renderTo;

      // 渲染UI
      var sliderbar = $('<div><div>&nbsp;</div><a>&nbsp;</a></div>').attr('class', ps.barCssName).css('width', ps.size.barWidth).appendTo(ps.renderTo);

      var completedbar = sliderbar.find('div:eq(0)').attr('class', ps.completedCssName);

      var slider = sliderbar.find('a').attr('class', ps.sliderCssName).css('width', ps.size.sliderWidth);

      var bw = sliderbar.width();
      var sw = slider.width();

      ps.limited = { min: 0, max: bw - sw - 2

        // 定位completedbar的填充长度以及slider左侧距离
      };if (typeof window.$sliderProcess === 'undefined') {
        window.$sliderProcess = function (obj1, obj2, left) {
          obj1.css('left', left);
          obj2.css('width', left);
        };
      }

      // eval('ps.limited.' + ps.initPosition)来获取，从而避免switch操作
      // 此处相当于调用 sliderProcess(xx,xx,xxx)   执行slider.css('left',value);completedbar.css('left',value)
      // $sliderProcess(slider, completedbar, eval('ps.limited.' + ps.initPosition))
      $sliderProcess(slider, completedbar, ps.initPosition);

      /* jQuery拖拽功能 */
      var slide = {
        drag: function drag(e) {
          var d = e.data;
          var l = Math.min(Math.max(e.pageX - d.pageX + d.left, ps.limited.min), ps.limited.max);
          $sliderProcess(slider, completedbar, l);
          ps.onChanging(l / ps.limited.max, e);
        },
        to: function to(l) {
          l = Math.min(l, ps.limited.max);
          $sliderProcess(slider, completedbar, l);
          ps.onChanging(l / ps.limited.max);
        },
        drop: function drop(e) {
          slider.removeClass(ps.sliderHover);
          ps.onChanged(parseInt(slider.css('left')) / ps.limited.max, e);
          // 去除绑定
          $('body').removeClass('un-selected').off('mousemove', slide.drag).off('mouseup', slide.drop);
        }

        // jSlider enable属性为true时，在end-user按下鼠标时绑定mousemove事件，
        // 在鼠标弹起时移除，我们只需要同步更新slider的left 属性和completedbar的width即可，
        // 同时在drag中绑定onChanging方法，在drop中绑定onChanged方法，
        // 向这两个方法推送的参数相同，1>百分比，即value值，介于0~1，2>event。
      };if (ps.enable) {
        slider.on('mousedown', function (e) {
          var d = {
            left: parseInt(slider.css('left')),
            pageX: e.pageX
          };
          $(this).addClass(ps.sliderHover);
          $('body').addClass('un-selected').on('mousemove', d, slide.drag).on('mouseup', d, slide.drop);
        });
        sliderbar.click(function (e) {
          var left = e.pageX - sliderbar.offset().left;
          slide.to(left);
        });
      }

      slider.data = { bar: sliderbar, completed: completedbar };
      slider.to = slide.to;
      return slider;
    }
  });
})(jQuery);

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_libs_jplayer_init_audio__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_api_services__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_config_read_solution_exlist__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_base64__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_pcm_play_worker_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_pcm_play_worker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_libs_pcm_play_worker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_gt__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_libs_gt__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by lycheng on 2019/9/5.
 */








var btnState = {
  unTTS: '立即合成',
  ttsing: '正在合成',
  endTTS: '立即播放',
  play: '停止播放',
  pause: '继续播放',
  endPlay: '重新播放',
  errorTTS: '合成失败'
};
var DEFAULT_TEXT = '科大讯飞成立于1999年，是中国先进的智能化语音技术提供商。我们提供的语音合成效果，达到了真正可商用的标准，您可以在这里输入任意文本进行语音合成体验。';

var isChrome = navigator.userAgent.toLowerCase().match(/chrome/);
var notSupportTip = isChrome ? '您的浏览器暂时不支持体验功能，请升级您的浏览器' : '您现在使用的浏览器暂时不支持体验功能，<br />推荐使用谷歌浏览器Chrome';

var audioCtx;
var source;

var Experience = function () {
  function Experience() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$speed = _ref.speed,
        speed = _ref$speed === undefined ? 2 : _ref$speed,
        _ref$voice = _ref.voice,
        voice = _ref$voice === undefined ? 7 : _ref$voice,
        _ref$pitch = _ref.pitch,
        pitch = _ref$pitch === undefined ? 7 : _ref$pitch,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? '' : _ref$text,
        _ref$engineType = _ref.engineType,
        engineType = _ref$engineType === undefined ? 'intp65' : _ref$engineType,
        _ref$tte = _ref.tte,
        tte = _ref$tte === undefined ? 'UTF8' : _ref$tte,
        _ref$voiceName = _ref.voiceName,
        voiceName = _ref$voiceName === undefined ? 'x_xiaofeng' : _ref$voiceName,
        _ref$playBtn = _ref.playBtn,
        playBtn = _ref$playBtn === undefined ? '.js-base-play' : _ref$playBtn,
        _ref$defaultText = _ref.defaultText,
        defaultText = _ref$defaultText === undefined ? '' : _ref$defaultText;

    _classCallCheck(this, Experience);

    this.speed = speed;
    this.voice = voice;
    this.pitch = pitch;
    this.text = text;
    this.defaultText = defaultText;
    this.engineType = engineType;
    this.tte = tte;
    this.voiceName = voiceName;
    this.playBtn = playBtn;
    this.playState = '';
    this.audioDatas = [];
    this.pcmPlayWork = new __WEBPACK_IMPORTED_MODULE_4_js_libs_pcm_play_worker_js___default.a();
    this.pcmPlayWork.onmessage = function (e) {
      _this.onmessageWork(e);
    };
  }

  _createClass(Experience, [{
    key: 'setConfig',
    value: function setConfig(_ref2) {
      var speed = _ref2.speed,
          voice = _ref2.voice,
          pitch = _ref2.pitch,
          text = _ref2.text,
          defaultText = _ref2.defaultText,
          engineType = _ref2.engineType,
          voiceName = _ref2.voiceName,
          tte = _ref2.tte;

      speed !== undefined && (this.speed = speed);
      voice !== undefined && (this.voice = voice);
      pitch !== undefined && (this.pitch = pitch);
      text && (this.text = text);
      defaultText && (this.defaultText = defaultText);
      engineType && (this.engineType = engineType);
      tte && (this.tte = tte);
      voiceName && (this.voiceName = voiceName);
      this.resetAudio();
    }
  }, {
    key: 'onmessageWork',
    value: function onmessageWork(e) {
      var _this2 = this;

      switch (e.data.command) {
        case 'newAudioData':
          {
            this.audioDatas.push(e.data.data);
            if (this.playState === 'ttsing' && this.audioDatas.length === 1) {
              this.playTimeout = setTimeout(function () {
                if (_this2.playState === 'unTTS') {
                  _this2.resetAudio();
                  return;
                }
                _this2.audioPlay();
              }, 1000);
            }
            break;
          }
      }
    }
  }, {
    key: 'setBtnState',
    value: function setBtnState(state) {
      var oldState = this.playState;
      this.playState = state;
      $(this.playBtn).removeClass(oldState).addClass(state).find('span').text(btnState[state]);
    }
  }, {
    key: 'getAudio',
    value: function getAudio(geetestResult) {
      var _this3 = this;

      this.setBtnState('ttsing');
      if (!this.captchaObj) {
        this.geetestInit();
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_js_api_services__["g" /* getTtsSign */](geetestResult).then(function (result) {
        if (_this3.playState === 'unTTS') {
          _this3.resetAudio();
          return;
        }
        if (result.flag) {
          var url = result.data.url.replace('https://', 'wss://');
          _this3.connectWebsocket(url);
        } else {
          $.alerts.alert(result.desc || result.msg || '合成体验签名获取失败');
          _this3.resetAudio();
          return false;
        }
      });
    }
  }, {
    key: 'connectWebsocket',
    value: function connectWebsocket(url) {
      var _this4 = this;

      if ('WebSocket' in window) {
        this.websocket = new WebSocket(url);
      } else if ('MozWebSocket' in window) {
        this.websocket = new MozWebSocket(url);
      } else {
        $.alerts.alert(notSupportTip);
        return;
      }
      var self = this;
      this.websocket.onopen = function (e) {
        if (_this4.playState === 'unTTS') {
          _this4.resetAudio();
          return;
        }
        var params = {
          'common': {
            'app_id': '5d50d68b' // APPID
          },
          'business': {
            'ent': self.engineType,
            'aue': 'raw',
            'auf': 'audio/L16;rate=16000',
            'vcn': self.voiceName,
            'speed': self.speed,
            'volume': self.voice * 10,
            'pitch': self.pitch,
            'bgs': 1,
            'tte': self.tte
          },
          'data': {
            'status': 2,
            'text': self.encodeText(self.text || self.defaultText || DEFAULT_TEXT, self.tte === 'unicode' ? 'base64&utf16le' : '')
          }
        };
        _this4.websocket.send(JSON.stringify(params));
      };
      this.websocket.onmessage = function (e) {
        if (_this4.playState === 'unTTS') {
          _this4.resetAudio();
          return;
        }
        var jsonData = JSON.parse(e.data);
        // 识别结束
        if (jsonData.code !== 0) {
          $.alerts.alert(jsonData.code + ':' + jsonData.message);
          self.resetAudio();
          _this4.websocket.close();
          return;
        }
        self.pcmPlayWork.postMessage({
          command: 'transData',
          data: jsonData.data.audio
        });

        if (jsonData.code === 0 && jsonData.data.status === 2) {
          _this4.websocket.close();
        }
      };
      this.websocket.onerror = function (e) {
        console.log(e);
      };
      this.websocket.onclose = function (e) {
        console.log(e);
      };
    }
  }, {
    key: 'encodeText',
    value: function encodeText(text, encoding) {
      switch (encoding) {
        case 'utf16le':
          {
            var buf = new ArrayBuffer(text.length * 4);
            var bufView = new Uint16Array(buf);
            for (var i = 0, strlen = text.length; i < strlen; i++) {
              bufView[i] = text.charCodeAt(i);
            }
            return buf;
          }
        case 'buffer2Base64':
          {
            var binary = '';
            var bytes = new Uint8Array(text);
            var len = bytes.byteLength;
            for (var _i = 0; _i < len; _i++) {
              binary += String.fromCharCode(bytes[_i]);
            }
            return window.btoa(binary);
          }
        case 'base64&utf16le':
          {
            return this.encodeText(this.encodeText(text, 'utf16le'), 'buffer2Base64');
          }
        default:
          {
            return __WEBPACK_IMPORTED_MODULE_3_js_base64__["Base64"].encode(text);
          }
      }
    }
  }, {
    key: 'resetAudio',
    value: function resetAudio() {
      this.audioPause();
      this.setBtnState('unTTS');
      this.audioDatasIndex = 0;
      this.audioDatas = [];
      this.websocket && this.websocket.close();
      clearTimeout(this.playTimeout);
    }
  }, {
    key: 'audioPlay',
    value: function audioPlay() {
      try {
        if (!audioCtx) {
          audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          audioCtx.resume();
        }
        if (!audioCtx) {
          $.alerts.alert(notSupportTip);
          return;
        }
      } catch (e) {
        $.alerts.alert(notSupportTip);
        return;
      }
      this.audioDatasIndex = 0;
      if (this.audioDatas.length && this.playState !== 'unTTS') {
        this.playSource();
        this.setBtnState('play');
      } else {
        this.audioDatas = [];
        if (!this.captchaObj) {
          this.geetestInit();
        } else {
          this.captchaObj.verify();
        }
      }
    }
  }, {
    key: 'audioPause',
    value: function audioPause(state) {
      if (this.playState === 'play') {
        this.setBtnState(state || 'endPlay');
      }
      clearTimeout(this.playTimeout);
      try {
        source && source.stop();
      } catch (e) {
        console.log(e);
      }
    }
  }, {
    key: 'playSource',
    value: function playSource() {
      var _this5 = this;

      var bufferLength = 0;
      var dataLength = this.audioDatas.length;
      for (var i = this.audioDatasIndex; i < dataLength; i++) {
        bufferLength += this.audioDatas[i].length;
      }
      var audioBuffer = audioCtx.createBuffer(1, bufferLength, 22050);
      var offset = 0;
      var nowBuffering = audioBuffer.getChannelData(0);
      for (var _i2 = this.audioDatasIndex; _i2 < dataLength; _i2++) {
        var audioData = this.audioDatas[_i2];
        if (audioBuffer.copyToChannel) {
          audioBuffer.copyToChannel(audioData, 0, offset);
        } else {
          for (var j = 0; j < audioData.length; j++) {
            nowBuffering[offset + j] = audioData[j];
          }
        }
        offset += audioData.length;
        this.audioDatasIndex++;
      }

      source = audioCtx.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(audioCtx.destination);
      source.start();
      source.onended = function (event) {
        if (_this5.playState !== 'play') {
          return;
        }
        if (_this5.audioDatasIndex < _this5.audioDatas.length) {
          _this5.playSource();
        } else {
          _this5.audioPause('endPlay');
        }
      };
    }
  }, {
    key: 'geetestInit',
    value: function geetestInit() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1_js_api_services__["i" /* getValidate */]().then(function (result) {
        initGeetest({
          gt: result.data.gt,
          challenge: result.data.challenge,
          offline: !result.data.success,
          new_captcha: result.data.new_captcha,
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          _this6.captchaObj = captchaObj;
          captchaObj.onReady(function () {
            captchaObj.verify();
          }).onSuccess(function () {
            var geetestResult = captchaObj.getValidate();
            if (!geetestResult) {
              return alert('请完成验证');
            }
            _this6.getAudio(geetestResult);
          });
        });
      });
    }
  }]);

  return Experience;
}();

/* harmony default export */ __webpack_exports__["a"] = (Experience);

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "9ecd076c9f1677d109bd.worker.js");
};

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return player; });
var player = function (my) {
  // 当前待播放音频地址
  var curUrl;
  // 上一个待播放音频地址
  var lastUrl;
  var $jplayer;
  // var Bubble
  // 回调函数
  var callback;

  var stopEvent = null;
  var playEvent = null;
  var playingEvent = null;
  var playErrorEvent = null;
  // 记录player监测flash未安装时是否发起请求swf文件
  var isReqSwf = false;
  // stoped后禁止调用canplay
  var canplayStatus = false;

  my.getStatus = function () {
    return $jplayer.attr('status');
  };

  my.buttonClick = function (url, cb, cbPlaying, cbStop, cbError, cbPlay) {
    // 保存回调
    callback = cb;
    // 重置回调
    stopEvent = cbStop;
    playEvent = cbPlay;
    playingEvent = cbPlaying;
    playErrorEvent = cbError;
    var urlParam = {};
    if (typeof url === 'string') {
      urlParam = {
        mp3: url
      };
    } else {
      urlParam = url;
    }

    // 保存上个元素的信息
    lastUrl = curUrl;
    curUrl = JSON.stringify(urlParam);

    if (lastUrl === curUrl) {
      my.play(false);
      return;
    }
    my.play(true);
  };
  // 播放：isNew==true，代表重新加载音频
  my.play = function (isNew) {
    if (isNew) {
      $jplayer.jPlayer('setMedia', JSON.parse(curUrl || '{}')).jPlayer('play');
    } else {
      $jplayer.jPlayer('play');
    }
  };
  my.playUrl = function (url) {
    curUrl = '';
    stopEvent = null;
    playEvent = null;
    playingEvent = null;
    playErrorEvent = null;
    var urlParam = {};
    if (typeof url === 'string') {
      urlParam = {
        mp3: url
      };
    } else {
      urlParam = url;
    }

    $jplayer.jPlayer('setMedia', urlParam).jPlayer('play');
  };
  // 暂停
  my.pause = function (t) {
    if (curUrl) {
      if (t === 0) {
        stopEvent = null;
        playEvent = null;
        playingEvent = null;
        playErrorEvent = null;
      }
      $jplayer.jPlayer('pause');
      if (stopEvent) {
        stopEvent();
      }
      if (callback) {
        callback();
      }
    }
  };
  // 停止
  my.stop = function () {
    if (this.getStatus() === '1' && curUrl) {
      $jplayer.jPlayer('stop');
    }
  };
  // 初始化
  my.init = function (baseUrl) {
    $jplayer = $('#jplayer');
    $jplayer.jPlayer({
      ready: function ready() {
        $jplayer.attr('status', '1');
      },
      // 监听播放事件 不是监听canplay事件
      play: function play(event) {
        if (!event.jPlayer.status.paused) {
          canplayStatus = true;
          if (event.jPlayer.status.duration === 0) {
            if (playEvent) {
              playEvent();
            }
          } else {
            if (playingEvent) {
              playingEvent();
            }
          }
        }
      },
      canplay: function canplay(event) {
        if (playingEvent && canplayStatus) {
          playingEvent();
        }
      },
      // 当播放结束时调用
      ended: function ended() {
        if (stopEvent) {
          canplayStatus = false;
          stopEvent();
        }
        if (callback) {
          curUrl = '';
          callback();
          callback = undefined;
        }
      },
      // 播放异常时调用
      error: function error(event) {
        // 如果浏览器选择使用flash播放，首次初始化播放器时监测flash是否满足使用
        // 如果不满足，百度统计一次，并请求一个空的swf文件触发浏览器下载flash插件
        if (!isReqSwf && event.jPlayer.version.flash === 'unknown') {
          $('#flashZone').html(genPlayerHtml('/flash/Jplayer.swf'));
          isReqSwf = true;
        }
        if (playErrorEvent) {
          playErrorEvent(event);
        }
      },
      // 播放器地址
      swfPath: '/hera/swf/Jplayer.swf',
      solution: 'html,flash',
      supplied: 'wav, mp3'
    });
  };
  function genPlayerHtml(flashUrl) {
    var htmlStr = '';
    htmlStr += '<object id="AudioFlashPlayer" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=8,0,0,0" width="0" height="0">';
    htmlStr += '<param name="movie" value="' + flashUrl + '" /> <param name="quality" value="high" /><param name="wmode" value="transparent" /> <param name="FlashVars" value="Caller= " /><param name="allowscriptaccess" value="sameDomain" /><param name="swfversion" value="10.0.22.0" />';
    htmlStr += '<embed src="' + flashUrl + '" id="AudioFlashPlayerFF"  width="0" height="0" quality="high"  pluginspage="http://www.adobe.com/shockwave/download/download.cgi?P1_Prod_Version=ShockwaveFlash" wmode="transparent" swfversion="10.0.22.0"  flashvars=""  type="application/x-shockwave-flash" allowscriptaccess="sameDomain" > ';
    htmlStr += '</embed></object>';
    return htmlStr;
  }

  return my;
}({});
player.init();


/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(5);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */





function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  var $suspension = $(".affix");
  var $backTop = $(".affix-bottom");
  var $panelSuggest = $(".affix-panel-content__suggest");
  var $panelApplet = $(".affix-panel-content__applet");
  var $panelAdvice = $(".affix-panel-content__advice");
  var $iframe = $(".affix-panel-content__iframe");
  var timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    user["e" /* getUserinfo */]().then(function (res) {
      if (res.code === 80000) {
        var jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = prod["a" /* config */].PASSPORT_NEW + "/login?jump=" + jumpBack;
      } else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*');
      }
    });
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    user["e" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["e" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + "/login?jump=" + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function setIframe(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
};
$(function () {
  window.addEventListener("message", function (e) {
    if (e.data.type === 'dom') {
      var data = e.data.data;

      var width = data.width;
      var height = data.height + 12;
      methods.setIframe(width, height);
    }
    if (e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show');
    }
  });
});


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/scss/solutions/readSolution.scss
var readSolution = __webpack_require__(849);
var readSolution_default = /*#__PURE__*/__webpack_require__.n(readSolution);

// EXTERNAL MODULE: ./node_modules/_babel-polyfill@6.26.0@babel-polyfill/lib/index.js
var lib = __webpack_require__(1);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/js/libs/utils-solutions.js
var utils_solutions = __webpack_require__(10);

// EXTERNAL MODULE: ./src/js/libs/utils-tab/index.scss
var utils_tab = __webpack_require__(850);
var utils_tab_default = /*#__PURE__*/__webpack_require__.n(utils_tab);

// CONCATENATED MODULE: ./src/js/libs/utils-tab/index.js
/**
 * Created by lycheng on 2019/7/9.
 */



function bindEvent() {
  $('.scope-tabs').on('click', '.tab-title-box > li', function () {
    var $this = $(this);
    var $tabTitleBox = $this.parent();
    var $tabConBox = $($tabTitleBox.data('for'));
    if (!$tabConBox.length) {
      $tabConBox = $tabTitleBox.closest('.scope-tabs').children('.tab-con-box');
    }
    var index = $this.index();
    var $sibling = $this.siblings('.active');
    $sibling.removeClass('active');
    $tabConBox.children('.active').removeClass('active');
    $this.addClass('active');
    $tabConBox.children().eq(index).addClass('active');
  });
}
bindEvent();
// EXTERNAL MODULE: ./src/js/libs/jquery.slider.js
var jquery_slider = __webpack_require__(175);
var jquery_slider_default = /*#__PURE__*/__webpack_require__.n(jquery_slider);

// EXTERNAL MODULE: ./src/js/libs/utils-tts-experience.js
var utils_tts_experience = __webpack_require__(176);

// EXTERNAL MODULE: ./src/js/config/read_solution_exlist.js
var read_solution_exlist = __webpack_require__(130);

// CONCATENATED MODULE: ./src/js/libs/utils-tts-read-solution.js
/**
 * Created by lycheng on 2019/9/5.
 */




var DEFAULT_TEXT = '科大讯飞成立于1999年，是中国先进的智能化语音技术提供商。我们提供的语音合成效果，达到了真正可商用的标准，您可以在这里输入任意文本进行语音合成体验。';

var experienceList = [];
var experienceCtrl = {
  init: function init() {
    experienceCtrl.render();
  },
  render: function render() {
    experienceCtrl.renderNovel();
    experienceCtrl.renderNews();
    experienceCtrl.renderHumancomputer();
  },
  renderNovel: function renderNovel() {
    var containerId = 'novel_experience';
    var experience = new utils_tts_experience["a" /* default */]({
      playBtn: '#' + containerId + ' .js-base-play'
    });
    experienceList.push(experience);
    var putonghuaSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(read_solution_exlist["a" /* exLists */].novel.putonghua || [], {
      key: 'putonghua',
      value: '普通话'
    });
    var otherSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(read_solution_exlist["a" /* exLists */].novel.other || [], {
      key: 'other',
      value: '方言及其他'
    });
    $('#' + containerId + ' .swiper-container').append(putonghuaSpeakerDOMStr + otherSpeakerDOMStr);
    experienceCtrl.voiceControl('#' + containerId + ' .voice', experience);
    experienceCtrl.speedControl('#' + containerId + ' .speed', experience);
    experienceCtrl.pitchControl('#' + containerId + ' .pitch', experience);
    experienceCtrl.bindEventNovel(experience);
  },
  renderNews: function renderNews() {
    var containerId = 'news_experience';
    var experience = new utils_tts_experience["a" /* default */]({
      playBtn: '#' + containerId + ' .js-base-play'
    });
    experienceList.push(experience);
    var newsSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(read_solution_exlist["a" /* exLists */].news);
    $('#' + containerId + ' .swiper-container').append(newsSpeakerDOMStr);
    experienceCtrl.voiceControl('#' + containerId + ' .voice', experience);
    experienceCtrl.speedControl('#' + containerId + ' .speed', experience);
    experienceCtrl.pitchControl('#' + containerId + ' .pitch', experience);
    experienceCtrl.bindEventNews(experience);
  },
  renderHumancomputer: function renderHumancomputer() {
    var containerId = 'humancomputer_experience';
    var experience = new utils_tts_experience["a" /* default */]({
      playBtn: '#' + containerId + ' .js-base-play'
    });
    experienceList.push(experience);
    var humancomputerSpeakerDOMStr = experienceCtrl.getSpeakersDOMStr(read_solution_exlist["a" /* exLists */].humancomputer);
    $('#' + containerId + ' .swiper-container').append(humancomputerSpeakerDOMStr);
    experienceCtrl.voiceControl('#' + containerId + ' .voice', experience);
    experienceCtrl.speedControl('#' + containerId + ' .speed', experience);
    experienceCtrl.pitchControl('#' + containerId + ' .pitch', experience);
    experienceCtrl.bindEventHumancomputer(experience);
  },
  getSpeakersDOMStr: function getSpeakersDOMStr(speakers) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var speakerDOMStr = '';
    var speakerNumPreSlide = 10;
    for (var i = 0; i < speakers.length; i++) {
      if (i % speakerNumPreSlide === 0) {
        speakerDOMStr += '<div class="swiper-wrapper" data-type=' + type.value + '><ul class="swiper-slide">';
      }
      speakerDOMStr += '\n      <li class="speaker" data-index="' + i + '" data-type="' + type.key + '">\n        <div class="speaker-img speaker-img-' + speakers[i].photoType + '">\n          <img src="/hera/img/speaker-photo/small/' + speakers[i].photo + '" />\n          ' + (speakers[i].tag ? '<i class="speaker-tag">' + speakers[i].tag + '</i>' : '') + '\n        </div>\n        <span class="speaker-name"><span>' + speakers[i].name + '</span></span>\n        <span class="speaker-desc">' + speakers[i].desc + '</span>\n      </li>\n      ';
      if (i % speakerNumPreSlide === 9 || i === speakers.length - 1) {
        speakerDOMStr += '</ul></div>';
      }
    }
    return speakerDOMStr;
  },
  voiceControl: function voiceControl(container, ex) {
    $.fn.jSlider({
      renderTo: $(container + ' .js-slider'),
      initPosition: 7 / 10 * 70,
      size: {
        barWidth: 70,
        sliderWidth: 5
      },
      onChanging: function onChanging(voice, e) {
        experienceCtrl.changeVoice(voice, container, ex);
      }
    });
    experienceCtrl.changeVoice(7, container, ex);
  },
  speedControl: function speedControl(container, ex) {
    $.fn.jSlider({
      renderTo: $(container + ' .js-slider'),
      initPosition: 35,
      size: {
        barWidth: 70,
        sliderWidth: 5
      },
      onChanging: function onChanging(speed, e) {
        experienceCtrl.changeSpeed(speed, container, ex);
      }
    });
    experienceCtrl.changeSpeed(2, container, ex);
  },
  pitchControl: function pitchControl(container, ex) {
    $.fn.jSlider({
      renderTo: $(container + ' .js-slider'),
      initPosition: 35,
      size: {
        barWidth: 70,
        sliderWidth: 5
      },
      onChanging: function onChanging(pitch, e) {
        experienceCtrl.changePitch(pitch, container, ex);
      }
    });
    experienceCtrl.changePitch(2, container, ex);
  },
  changePitch: function changePitch(pitch, container, ex) {
    var pitchList = [{
      value: '最慢',
      key: 0
    }, {
      value: '较慢',
      key: 25
    }, {
      value: '正常',
      key: 50
    }, {
      value: '较快',
      key: 75
    }, {
      value: '最快',
      key: 100
    }];
    // spd--语速（x-slow、slow、medium、fast、x-fast、default，或者设0-10之间的整数）
    pitch = pitch <= 1 ? Math.floor(pitch * pitchList.length) : pitch;
    if (pitch === pitchList.length) {
      pitch = pitch - 1;
    }
    $(container + ' .js-slider-text').text(pitchList[pitch].value);
    ex.setConfig({ pitch: pitchList[pitch].key });
  },
  changeSpeed: function changeSpeed(speed, container, ex) {
    var speedList = [{
      value: '最慢',
      key: 0
    }, {
      value: '较慢',
      key: 25
    }, {
      value: '正常',
      key: 50
    }, {
      value: '较快',
      key: 75
    }, {
      value: '最快',
      key: 100
    }];
    // spd--语速（x-slow、slow、medium、fast、x-fast、default，或者设0-10之间的整数）
    speed = speed <= 1 ? Math.floor(speed * speedList.length) : speed;
    if (speed === speedList.length) {
      speed = speed - 1;
    }
    $(container + ' .js-slider-text').text(speedList[speed].value);
    ex.setConfig({ speed: speedList[speed].key });
  },
  changeVoice: function changeVoice(voice, container, ex) {
    // vol--音量（silent、x-soft、soft、medium、loud、x-loud、default、或者设0-10之间的整数）
    voice = voice <= 1 ? Math.floor(voice * 9) + 1 : voice;
    $(container + ' .js-slider-text').text(voice);
    ex.setConfig({ voice: voice });
  },
  changeText: function changeText(text, ex) {
    ex.setConfig({ text: text });
  },
  bindEventNovel: function bindEventNovel(exNovel) {
    var swiper = new Swiper('#novel_swiper_speaker', {
      direction: 'vertical',
      pagination: '#novel_swiper_speaker .swiper-pagination',
      paginationClickable: true,
      mousewheelControl: true,
      observer: true,
      observeParents: true,
      onSlideChangeEnd: function onSlideChangeEnd(swiper) {
        var type = $('#novel_swiper_speaker .swiper-wrapper').eq(swiper.activeIndex).data('type');
        $('#novel_speaker_type').text(type);
      }
    });
    $('#novel_experience').on('click', '.speaker', function () {
      $('#novel_swiper_speaker .speaker.active').removeClass('active');
      $(this).addClass('active');
      var index = $(this).data('index');
      var type = $(this).data('type');
      var exSpeakerLists = read_solution_exlist["a" /* exLists */].novel;
      var speaker = exSpeakerLists[type][index];
      var defaultText = speaker.text || DEFAULT_TEXT;
      $('#novel_experience textarea').val(speaker.text).keyup(); // .prop('placeholder', defaultText)
      exNovel.setConfig({
        engineType: speaker.engineType,
        voiceName: speaker.enName,
        text: speaker.text || '',
        defaultText: defaultText
      });
    }).on('change', 'textarea', function () {
      var text = this.value || '';
      exNovel.setConfig({ text: text });
      $(this).keyup();
    }).on('keyup', 'textarea', function () {
      var len = this.value.length;
      $(this).next().text(len + '/200');
      len && exNovel.resetAudio();
    }).on('click', '.js-base-play', function () {
      if ($(this).hasClass('play')) {
        exNovel.audioPause();
      } else {
        experienceCtrl.stopAllAudio();
        exNovel.audioPlay();
      }
    });
    $('#novel_swiper_speaker .speaker:eq(0)').click();
  },
  bindEventNews: function bindEventNews(exNews) {
    var exSpeakerLists = read_solution_exlist["a" /* exLists */].news;
    if (exSpeakerLists.length > 10) {
      var swiper = new Swiper('#news_swiper_speaker', {
        direction: 'vertical',
        pagination: '#news_swiper_speaker .swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observer: true,
        observeParents: true
      });
    }
    experienceCtrl.bindEventItem('news_experience', exNews, exSpeakerLists);
  },
  bindEventHumancomputer: function bindEventHumancomputer(exHumancomputer) {
    var exSpeakerLists = read_solution_exlist["a" /* exLists */].humancomputer;
    if (exSpeakerLists.length > 10) {
      var swiper = new Swiper('#humancomputer_swiper_speaker', {
        direction: 'vertical',
        pagination: '#humancomputer_swiper_speaker .swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observer: true,
        observeParents: true
      });
    }
    experienceCtrl.bindEventItem('humancomputer_experience', exHumancomputer, exSpeakerLists);
  },
  bindEventItem: function bindEventItem(containerId, ex, exSpeakerLists) {
    $('#' + containerId).on('click', '.speaker', function () {
      $('#' + containerId + ' .speaker.active').removeClass('active');
      $(this).addClass('active');
      var index = $(this).data('index');
      var speaker = exSpeakerLists[index];
      var defaultText = speaker.text || DEFAULT_TEXT;
      $('#' + containerId + ' textarea').val(speaker.text).keyup();
      ex.setConfig({
        engineType: speaker.engineType,
        voiceName: speaker.enName,
        text: speaker.text || '',
        defaultText: defaultText
      });
    }).on('change', 'textarea', function () {
      var text = this.value || '';
      ex.setConfig({ text: text });
      $(this).keyup();
    }).on('keyup', 'textarea', function () {
      var len = this.value.length;
      $(this).next().text(len + '/200');
      len && ex.resetAudio();
    }).on('click', '.js-base-play', function () {
      if (ex.playState === 'play') {
        ex.audioPause();
      } else {
        experienceCtrl.stopAllAudio();
        ex.audioPlay();
      }
    });
    $('#' + containerId + ' .speaker:eq(0)').click();
  },
  stopAllAudio: function stopAllAudio() {
    experienceList.map(function (item) {
      item.audioPause();
    });
  }
};
/* harmony default export */ var utils_tts_read_solution = (experienceCtrl);
// CONCATENATED MODULE: ./src/js/entry/solutions/readSolution.js







$(function () {
  utils_tts_read_solution.init();
});

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export floatMenu */
/**
 * Created by lycheng on 2017/12/4.
 * 右边导航
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    difference: 5, // 为了避免top与tops临界点差值过小时，animate不触发的问题
    $container: $('html,body'),
    checkedClass: 'nav-checked'
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-custom-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top + floatMenu.config.difference;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-custom-nav-fall');
      var $navItem = $('.js-custom-nav-fall li');
      var targets = [];
      var i = 0;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        if ($('.' + targets[i]).offset()) {
          tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
        }
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 300) {
        $navCon.show();
      } else {
        $navCon.hide();
      }
    }

  }
};
floatMenu.init();


/***/ })

},[848]);


// WEBPACK FOOTER //
// js/solutions/readSolution.73d5c81cd136d7faa96e.bundle.js